/**
 * وضعیتِ «دیده‌شدن» راهنماها و توضیح‌های بخش‌ها در localStorage.
 * برای هر شناسه فقط یک‌بار (اولین مراجعه) نمایش داده می‌شود.
 */

const KEY = (id) => `bndbs:guide:${id}`;

export function hasSeenGuide(id) {
    try {
        return localStorage.getItem(KEY(id)) === "1";
    } catch (e) {
        return false;
    }
}

export function markGuideSeen(id) {
    try {
        localStorage.setItem(KEY(id), "1");
    } catch (e) {
        /* noop */
    }
}

export function resetGuide(id) {
    try {
        localStorage.removeItem(KEY(id));
    } catch (e) {
        /* noop */
    }
}

export default { hasSeenGuide, markGuideSeen, resetGuide };
